// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeviceTrafficMessage,
  unionToDeviceTrafficMessage,
  unionListToDeviceTrafficMessage,
} from "./device-traffic-message";
import {
  ElevatorTrafficMessage,
  ElevatorTrafficMessageT,
  verifyElevatorTrafficMessage,
} from "./elevator-traffic-message";
import {
  EscalatorTrafficMessage,
  EscalatorTrafficMessageT,
  verifyEscalatorTrafficMessage,
} from "./escalator-traffic-message";

export class TrafficMessage implements flatbuffers.IUnpackableObject<TrafficMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): TrafficMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsTrafficMessage(bb: flatbuffers.ByteBuffer, obj?: TrafficMessage): TrafficMessage {
    return (obj || new TrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsTrafficMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: TrafficMessage,
  ): TrafficMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new TrafficMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  messageType(): DeviceTrafficMessage {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceTrafficMessage.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startTrafficMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: DeviceTrafficMessage) {
    builder.addFieldInt8(0, messageType, DeviceTrafficMessage.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endTrafficMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createTrafficMessage(
    builder: flatbuffers.Builder,
    messageType: DeviceTrafficMessage,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    TrafficMessage.startTrafficMessage(builder);
    TrafficMessage.addMessageType(builder, messageType);
    TrafficMessage.addMessage(builder, messageOffset);
    return TrafficMessage.endTrafficMessage(builder);
  }

  unpack(): TrafficMessageT {
    return new TrafficMessageT(
      this.messageType(),
      (() => {
        const temp = unionToDeviceTrafficMessage(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: TrafficMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToDeviceTrafficMessage(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): TrafficMessageT {
    const t = new TrafficMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToDeviceTrafficMessage(this.messageType(), this.message.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class TrafficMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: DeviceTrafficMessage = DeviceTrafficMessage.NONE,
    public message: ElevatorTrafficMessageT | EscalatorTrafficMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return TrafficMessage.createTrafficMessage(builder, this.messageType, message);
  }

  clone(): TrafficMessageT {
    const obj = new TrafficMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: TrafficMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyTrafficMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorTrafficMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorTrafficMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorTrafficMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorTrafficMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
